import React, { useState, useEffect, useContext, useRef } from 'react'
import { Form, Input,Cascader, Row, Col, Select, Button,AutoComplete, Modal, notification, message, Divider } from 'antd';
import { GlobalData } from './SeminarFile';
import Services from '../../network/Services';
import konsole from '../../network/konsole';
import './Seminar.css'
import AddEditSpeakerModal from '../AddEditSpeakerModal';
import { UserContext } from '../../App';
import config from '../../config.json'
import InputMask from '../PhoneInputMask';
import Classroom from '../Classroom/Classroom';
import { isValidFuntion } from '../../control/Constant';


const Coordinator = (props) => {
  const { setLoader } = useContext(UserContext)
  const { getDataId, getCoordContactPerson, getCoordEmail, getCoordContactNo, setSubtenantIdAgain, editFuncData, stopEditFunc, setStopEditFunc, previewData } = useContext(GlobalData)
  const { getDataName, idValueSubtenant } = useContext(GlobalData)
  const [form] = Form.useForm();
  const [coordinatorId, setCoordinatorId] = useState("")
  const [coordinatorName, setCoordinatorName] = useState("")
  const [coordUserIdApi, setCoordUserIdApi] = useState("")
  const [coordinatorNameFromApiRes, setCoordinatorNameFromApiRes] = useState("")
  const [coordinatorspeakertype, setcoordinatorspeakertype] = useState('Coordinator')
  const [coOrdinatorList, setCoOrdinatorList] = useState([])
  const [primaryMobile, setPrimaryMobile] = useState();
  const [primaryEmail, setPrimaryEmail] = useState('');
  const [editCoordinator, setEditCoordinator] = useState("")
  const [sendLoggedUserId, setSendLoggedUserId] = useState("")
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [getFName, setGetFName] = useState("")
  const [getLName, setGetLName] = useState("")
  const [getEmail, setGetEmail] = useState("")
  const [getcountrycode, setcountrycode] = useState('')
  const [getContact, setGetContact] = useState("")
  const [getEmailCoordinatorApi, setGetEmailCoordinatorApi] = useState("")
  const [getMobileNoCoorApi, setGetMobileNoCoorApi] = useState("")
  const [sendCoordName, setSendCoordName] = useState("")
  const [openCoordDropdown, setOpenCoordDropdown] = useState(false)
  const [selectedCoordIds, setSelectedCoordIds] = useState([])
  const [coordSearchText, setCoordSearchText] = useState("")
  const coordDropdownRef = useRef(null)




  useEffect(() => {
    if (previewData?.getCoordinatorID?.length > 0) {
      props.form.setFieldsValue({
        'coordinatorField': previewData?.getCoordinatorID
      })
      setSelectedCoordIds(previewData?.getCoordinatorID)
    }
  }, [previewData])

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (coordDropdownRef.current && !coordDropdownRef.current.contains(e.target)) {
        setOpenCoordDropdown(false)
        setCoordSearchText("")
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])


  const { Option } = Select;



  let getIdOfSubtenant = props.subtenantValueId;


  useEffect(() => {
    let loggedIdUser = sessionStorage.getItem('loggedUserId')
    setSendLoggedUserId(loggedIdUser)
    if (isValidFuntion(editFuncData)) {
      userListApiCall(editFuncData?.subtenantId);


    } else {

      if (isValidFuntion(getIdOfSubtenant)) {
        let userroleId = JSON.parse(sessionStorage.getItem("stateObj")).roleId

        if (userroleId !== "11") {


          props.form.setFieldsValue({
            "coordinatorField": previewData?.getCoordinatorID,
            "coordinatorContact": " ",
            "coordinatorEmail": " "

          })
          // setTimeout(()=>{
          //   props.form.setFieldsValue({
          //     "coordinatorField": undefined,
          //     "coordinatorContact": "",
          //     "coordinatorEmail": ""

          //   })
          // },2000)
          userListApiCall(getIdOfSubtenant);
        } else {
          userListApiCall(getIdOfSubtenant);

        }
      } else {
        if (isValidFuntion(props.form.getFieldsValue().seminarOrganizingPartner)) {
          userListApiCall(props.form.getFieldsValue().seminarOrganizingPartner);
        }
      }
    }




  }, [getIdOfSubtenant])





  const userListApiCall = (RunApiWithSubtenantId) => {
    Services.getUserListByRoleId(RunApiWithSubtenantId, true, 6)
        .then((res) => {
            const objCoordinator = [];
            let filteredCoordinator = null;

            if (isValidFuntion(editFuncData) && !stopEditFunc) {
                filteredCoordinator = res.data.data.find(x => x.userId === editFuncData?.coordinators[0]?.coordinatorUserId);
                if (filteredCoordinator) {
                    setEditCoordinator(filteredCoordinator.fullName);
                    setPrimaryMobile(filteredCoordinator.primaryMobile);
                    setPrimaryEmail(filteredCoordinator.primaryEmail);
                    setCoordinatorId(filteredCoordinator.userId);
                    setCoordinatorName(filteredCoordinator.fullName);

                    const sPhoneNumber = filteredCoordinator.primaryMobile.split("");
                    const removeCountryCode = sPhoneNumber.splice(sPhoneNumber.length - 10, 10);

                    props.form.setFieldsValue({
                        coordinatorContact: removeCountryCode.join(""),
                        coordinatorEmail: filteredCoordinator.primaryEmail
                    });
                }
            }

            res.data.data.forEach((coordinator) => {
                objCoordinator.push({
                    value: coordinator.userId,
                    label: coordinator.fullName
                });
            });

            if (editFuncData && !stopEditFunc) {
                const edditCoordinatorArray = editFuncData.coordinators.map(coordinator => coordinator.coordinatorUserId);
                props.form.setFieldsValue({
                    coordinatorField: edditCoordinatorArray
                });
                setSelectedCoordIds(edditCoordinatorArray);
                getDataId(edditCoordinatorArray);
            }

            const objCoordinatorFilter = objCoordinator.filter((v, i, a) => a.findIndex(v2 => v2.value === v.value) === i);
            setCoOrdinatorList(objCoordinatorFilter);
            setIsModalVisible(false);
            form.resetFields();
            setLoader(false);
        })
        .catch((error) => {
            setLoader(false);
        });
};





  const fixCoordinatorAllFields = (coordinatorUserID) => {
    let userId = coordinatorUserID;
    konsole.log("fixCoordinatorAllFields", userId, "aaaaaaaaaaaaaaaaaaaaaaaaaa", coOrdinatorList)
    // let resultfilter = coOrdinatorList.filter(function (items) {
    //   return items.userId == userId;
    // });

    // resultfilter.map((item) => {
    //   konsole.log('mapresultfilter', item)
    //   setPrimaryMobile(item.primaryMobile);
    //   setPrimaryEmail(item.primaryEmail)
    //   konsole.log(item.primaryEmail);
    //   konsole.log(item.primaryMobile);
    //   setCoordinatorId(item.userId)
    //   setCoordinatorName(item.fullName)
    //   props.form.setFieldsValue({
    //     "coordinatorField": item.fullName,
    //     "coordinatorContact": item.primaryMobile,
    //     "coordinatorEmail": item.primaryEmail

    //   })


    // })
  }


  const selectPrimaryContactEmail = (fullName, key) => {
    konsole.log("SelectfullName", fullName, key)
    konsole.log("key", key)
    let userId = key.key;
    konsole.log(userId)
    let resultfilter = coOrdinatorList.filter(function (items) {
      return items.userId == userId;
    });

    resultfilter.map((item) => {
      konsole.log('mapresultfilter', item)
      setPrimaryMobile(item.primaryMobile);
      setPrimaryEmail(item.primaryEmail)
      konsole.log(item.primaryEmail);
      konsole.log(item.primaryMobile);
      setCoordinatorId(item.userId)
      setCoordinatorName(item.fullName)
      let sPhoneNumber = item.primaryMobile.split("")
      let removeCountryCode = sPhoneNumber.splice(sPhoneNumber.length - 10, 10)
      konsole.log("sPhoneNumber", removeCountryCode.join(""));

      props.form.setFieldsValue({
        // "coordinatorField": item.fullName,
        "coordinatorContact": removeCountryCode.join(""),
        "coordinatorEmail": item.primaryEmail

      })


    })
    if (editFuncData !== null && editFuncData !== undefined && editFuncData !== "") {

      setStopEditFunc(true)
    }
  }


  getDataName(coordinatorName || coordinatorNameFromApiRes)




  const showModal = () => {
    let userroleId = JSON.parse(sessionStorage.getItem("stateObj")).roleId
    let subtenantId = sessionStorage.getItem("subtenantId")


    if (userroleId == "4") {
      if (props.form.getFieldsValue().seminarOrganizingPartner !== undefined || (editFuncData !== null && editFuncData !== undefined && editFuncData !== "")) {

        setIsModalVisible(true);

        konsole.log("roleIdroleId", userroleId)
      } else {
        konsole.log("roleIdroleId", 11)
        message.info("Please Select Seminar Organizing Firm")

      }

    } else {

      setIsModalVisible(true);
    }

    if (userroleId == "4") {
      if (editFuncData !== null && editFuncData !== undefined && editFuncData !== "") {
        postSubtenantDetails(editFuncData?.subtenantId)
      } else {
        postSubtenantDetails(props.form.getFieldsValue().seminarOrganizingPartner)

      }
    }


    if (userroleId == "11" || userroleId == "6") {
      postSubtenantDetails(subtenantId)

    }



  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    // form.resetFields();
    setIsModalVisible(false);

  };

  const HideBack = (dataCoori) => {
    konsole.log("dataCoori", dataCoori)
    SubmitData(dataCoori.firstName, dataCoori.lastname);




  }


  const openNotification = (placement, Status) => {

    if (Status == 500) {

      notification.error({
        message: `Error ${Status} `,
        description:
          'Server Issue! Please try after sometime.',
        placement,
      });
    } else if (Status == 200) {
      notification.success({
        message: `Organizer Contact added successfully`,

        placement,
      });
    }

  };

  const onChangePhone = (value) => {
    // konsole.log("value",value);
    form.setFieldsValue({
      coordinatorContact: value,
    });
  };

  const SubmitData = (firstCoordinateName, lastCoordinateName) => {

    setLoader(true)


    let userroleId = JSON.parse(sessionStorage.getItem("stateObj")).roleId

    let subtenentIdForEdit;
    if (userroleId == "4") {

      if (editFuncData !== null && editFuncData !== undefined && editFuncData !== "") {
        subtenentIdForEdit = editFuncData?.subtenantId
      } else {
        subtenentIdForEdit = props.form.getFieldsValue().seminarOrganizingPartner
      }

    } else if (userroleId == "11" || userroleId == "6") {
      konsole.log("props.form.getFieldsValue().seminarOrganizingPartner", props.form.getFieldsValue().seminarOrganizingPartner)
      subtenentIdForEdit = props.form.getFieldsValue().seminarOrganizingPartner
    }




    const jsonObjData = {
      subtenantId: subtenentIdForEdit,
      signUpPlateform: config.AOADMIN,
      createUserCredentials: true,
      createdBy: sendLoggedUserId,
      user: {
        roleId: 6,
        firstName: firstCoordinateName,
        lastName: lastCoordinateName,
        emailAddress: getEmail,
        userName: getEmail,
        countryCode: getcountrycode,
        mobileNumber: getContact,
        // password: "stringst",
        packageCode: null,
        activateUser: false,
        autoConfirmEmail: false,
        autoConfirmMobile: false
      }
    }

    konsole.log("jsonObjData", JSON.stringify(jsonObjData))
    konsole.log("jsonObjData", jsonObjData)




    const speakerRegisterApi = Services.subtenantCreateUser(jsonObjData)
    speakerRegisterApi.then((res) => {
      konsole.log("coordinatorresponse", res)
      konsole.log("SpeakerResasdsada", res.data.data)
      konsole.log("SpeakerRes", res.data.data.userId)
      let fixefFullName = res.data.data.firstName + " " + res.data.data.lastName;
      setCoordinatorNameFromApiRes(fixefFullName)
      props.form.setFieldsValue({
        //  "coordinatorField": fixefFullName,
        "coordinatorContact": getContact,
        "coordinatorEmail": getEmail
      })

      setCoordinatorId(res.data.data.userId)
      setGetEmailCoordinatorApi(getEmail)
      setGetMobileNoCoorApi(getContact)
      userListApiCall(props.subtenantValueId);
      openNotification('topRight', res.status)

    }).catch((err) => {
      konsole.log("errr", err)
      konsole.log("errrCoordinator", err.response.data.messages[1].split(" ").splice(0, 5).join(" "));
      if (err.response.data.messages[0] == "ALREADY_REGISTERED") {
        message.error(err.response.data.messages[1])
      }
      setLoader(false)
    }).finally(() => {
      setLoader(false)
    })



  }



  const CoordName = (e) => {
    setSendCoordName(e)
  }

  getCoordContactPerson(sendCoordName || coordinatorNameFromApiRes)
  getCoordContactNo(primaryMobile || getMobileNoCoorApi)
  getCoordEmail(primaryEmail || getEmailCoordinatorApi)



  const postSubtenantDetails = (getSubtenantId) => {
    let userroleId = JSON.parse(sessionStorage.getItem("stateObj")).roleId
    let postSubtenantDetailApiCall = Services.postSubtenantDetails()
    postSubtenantDetailApiCall.then((res) => {
      konsole.log("responsedetails", res.data)
      // setpostSubtenantDetailResp(res.data.data)
      if (userroleId == "4") {

        if (editFuncData !== undefined && editFuncData !== null && editFuncData !== "") {
          let filterSubtenant = res.data.data.filter((x) => {
            return x.subtenantId == getSubtenantId
          })
          //   fixedEditValue(filterSubtenant)
          konsole.log("filterSubtenantCoordinator", filterSubtenant)
          form.setFieldsValue({
            "Subtenant": filterSubtenant[0]?.subtenantName
          })
        } else {
          let filterSubtenantId = res.data.data.filter((x) => {
            return x.subtenantId == getSubtenantId
          })
          //   fixedEditValue(filterSubtenant)
          konsole.log("filterSubtenantCoordinator", filterSubtenantId)
          form.setFieldsValue({
            "Subtenant": filterSubtenantId[0]?.subtenantName
          })
        }
      } else if (userroleId == "11" || userroleId == "6") {

        let filterSubtenant = res.data.data.filter((x) => {
          return x.subtenantId == getSubtenantId
        })
        //   fixedEditValue(filterSubtenant)
        konsole.log("filterSubtenantCoordinator", filterSubtenant)
        form.setFieldsValue({
          "Subtenant": filterSubtenant[0]?.subtenantName
        })

      }
    })
      .catch((error) => {
        konsole.log("error", error)
      })

  }



  const multiCoordinatorChange = (e) => {
    // konsole.log("multiCoordinatorChangemultiCoordinatorChange", e);
    // let userId = key.map((x)=>{
    //   return x.key
    // })
    konsole.log("multiCoordinatorChangemultiCoordinatorChange", e)
    getDataId(e);
    setStopEditFunc(true)

    // callNewFunc(userId)
  };


  return (
    <div className='m-0'>
      <p className='fs-4 fw-bold seminartxt' style={{ paddingLeft: "7px" }}>Coordinator</p>

      <Form.Provider
        onFormFinish={(name, { values, forms }) => {
          if (name === 'userForm') {
            const { basicForm } = forms;
            setIsModalVisible(false);
          }
        }}
      >
        <div className='' style={{marginRight:"30px"}}>
          <Form.Item
            name="coordinatorField"
            label="Name of Contact Person"
            rules={[{ required: true, message: "Feild is required!" }]}
            getValueProps={() => ({ value: selectedCoordIds })}
          >
            <div ref={coordDropdownRef} style={{ position: "relative" }}>
              <div
                onClick={() => setOpenCoordDropdown(prev => !prev)}
                style={{
                  border: "1px solid #474747",
                  padding: "6px 12px",
                  borderRadius: 2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer",
                  background: "#fff",
                  fontSize: 14,
                  minHeight: "44px",
                }}
              >
                <span style={{ display: "flex", flexWrap: "wrap", gap: 4, flex: 1, overflow: "hidden" }}>
                  {(() => {
                    const selectedLabels = coOrdinatorList
                      ?.filter(o => selectedCoordIds?.includes(o.value))
                      ?.map(o => o.label)
                    if (!selectedLabels?.length) {
                      return <span style={{ color: "#474747" }}>Select Coordinator</span>
                    }
                    return (
                      <>
                        <span style={{
                          background: "#f0f0f0", border: "1px solid #d9d9d9", borderRadius: 4,
                          padding: "2px 8px", fontSize: 13, color: "#333", whiteSpace: "nowrap"
                        }}>
                          {selectedLabels?.[0]}
                        </span>
                        {selectedLabels?.length > 1 && (
                          <span style={{
                            background: "#f0f0f0", border: "1px solid #d9d9d9", borderRadius: 4,
                            padding: "2px 8px", fontSize: 13, color: "#333", whiteSpace: "nowrap"
                          }}>
                            +{selectedLabels?.length - 1}
                          </span>
                        )}
                      </>
                    )
                  })()}
                </span>
                <span style={{
                  display: "inline-block",
                  transition: "transform 0.2s",
                  transform: openCoordDropdown ? "rotate(180deg)" : "rotate(0deg)",
                  marginLeft: 8,
                  flexShrink: 0,
                }}>
                  <img src="/black_select.svg" style={{ height: 16, width: 12 }} alt="" />
                </span>
              </div>

              {openCoordDropdown && (
                <div style={{
                  position: "absolute",
                  top: "calc(100% + 4px)",
                  left: 0,
                  right: 0,
                  background: "#fff",
                  border: "1px solid #d9d9d9",
                  borderRadius: 6,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  zIndex: 1000,
                }}>

                  <div style={{ padding: "8px 10px", borderBottom: "1px solid #f0f0f0" }}>
                    <input
                      type="text"
                      autoFocus
                      placeholder="Search coordinator..."
                      value={coordSearchText}
                      onChange={e => setCoordSearchText(e.target.value)}
                      onClick={e => e.stopPropagation()}
                      className="coord-search-input"
                      style={{
                        width: "100%",
                        padding: "6px 10px",
                        border: "1px solid #474747",
                        borderRadius: 2,
                        fontSize: 13,
                        outline: "none",
                        boxSizing: "border-box",
                        height: "44px",
                        color: "#474747",
                      }}
                    />
                  </div>

                  <div style={{ maxHeight: 180, overflowY: "auto", padding: "4px 0" }}>
                    {coOrdinatorList
                      ?.filter(item =>
                        item.label.toLowerCase().includes(coordSearchText.toLowerCase())
                      )
                      ?.map(item => {
                        const isChecked = selectedCoordIds?.includes(item.value)
                        return (
                          <div key={item.value} className="coord-dropdown-item"
                            style={{ background: isChecked ? "#fdf0f2" : "transparent" }}
                          >
                            <label style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                              cursor: "pointer",
                              fontSize: 14,
                              padding: "6px 12px",
                              margin: 0,
                              width: "100%",
                            }}>
                              <input
                                type="checkbox"
                                style={{ height: "16px", width: "16px" }}
                                checked={isChecked}
                                onChange={() => {
                                  const updated = isChecked
                                    ? selectedCoordIds?.filter(id => id !== item.value)
                                    : [...selectedCoordIds, item.value]
                                  setSelectedCoordIds(updated)
                                  props.form.setFieldsValue({ coordinatorField: updated })
                                  multiCoordinatorChange(updated)
                                }}
                              />
                              {item.label}
                            </label>
                          </div>
                        )
                      })
                    }
                    {coOrdinatorList?.filter(item =>
                      item.label.toLowerCase()?.includes(coordSearchText.toLowerCase())
                    )?.length === 0 && (
                      <div style={{ padding: "10px 12px", color: "#999", fontSize: 13 }}>
                        No coordinator found
                      </div>
                    )}
                  </div>

                  <Divider style={{ margin: "8px 0" }} />
                  <div className='d-flex justify-content-end'>
                    <div className='me-2 mb-3 mt-1'>
                      <Button
                        style={{
                          background: "#720c20",
                          color: "white",
                          borderRadius: "2px",
                          fontWeight: 500,
                          height: "44px",
                          border: "none",
                        }}
                        onClick={(e) => {
                          e.stopPropagation()
                          setOpenCoordDropdown(false)
                          setCoordSearchText("")
                          showModal()
                        }}
                      >
                        Add Coordinator
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Form.Item>
        </div>

        {/* <Row className='d-flex'>
          <Col flex={4} xs={24} sm={12}>
            <Form.Item
              name="coordinatorContact"
              label="Contact"
            rules={[
              {
                required: true,
                message: "Contact Number Is Required!"
              }
            ]}
            >
              <Input className='border-2 respCoor '
              disabled = {(editFuncData !==undefined && editFuncData !== null && editFuncData !== "")? true : false}
              />
              <Input className='border-2 respCoor ' />
              <InputMask placeholder=""
               disabled = {(editFuncData !==undefined && editFuncData !== null && editFuncData !== "")? true : false}
              value={form.getFieldsValue().coordinatorContact} onValueChange={onChangePhone} />

            </Form.Item>
          </Col>
          <Col flex={4} xs={24} sm={12} >
            <Form.Item

              name="coordinatorEmail"
              label="Email"
              className="ms-2 "
            rules={[
              {
                type: 'email',
                message: 'The input is not valid E-mail!',
              },
              {
                required: true,
                message: 'Please input your E-mail!',
              },
            ]}
            rules={[
              {
                required: true,
                message: "Email Id is required!"
              }
            ]}
            >
              <Input className='border-2 respCoor '
              disabled = {(editFuncData !==undefined && editFuncData !== null && editFuncData !== "")? true : false}
              />
            </Form.Item>
          </Col>
        </Row> */}

        <Modal
          centered
          visible={isModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={null}
          closable={false}
          maskClosable={false}
          enforceFocus={false}
          width={800}
      style={{ top: 20 }}
      bodyStyle={{ padding: '0px', borderRadius: '8px' }}
        >
           <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 10px 12px 10px', borderBottom: '1px solid #bfbfbf' }}>
          <p style={{ fontSize: '16px', fontWeight: '700', color: '#333333', margin: 0 }}>
            Add Coordinator
          </p>
          <span onClick={handleCancel} style={{ cursor: 'pointer', fontSize: '25px', color: '#333333', lineHeight: 1, padding: '2px 6px' }}>×</span>
        </div>
        <div style={{padding:"14px"}}>
          <Form form={form} name="AddEditSpeakerform"
            onFinish={HideBack}
            layout="vertical"
            style={{
              maxHeight: 'calc(100vh - 90px)',
              overflowY: 'auto'
            }}
          >
            <Row className='w-100 mt-1'  >
              <Col xs={24} lg={24} style={{ paddingRight: "8px" }}>
                <Form.Item label="Subtenant Name" name="Subtenant"
                  rules={[{ required: true, message: 'Please input your Name!' }]}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
              <AddEditSpeakerModal form={form} visible={isModalVisible} onCancel={handleCancel} setGetFName={setGetFName} setGetLName={setGetLName} setGetEmail={setGetEmail} setGetContact={setGetContact} getCoordName={sendCoordName} setcountrycode={setcountrycode} coordinatorspeakertype={coordinatorspeakertype} />
            </Row>
            {/* <Button type='primary' onClick={SubmitData} htmlType='submit'>Add</Button> */}
            <div className='d-flex justify-content-end mt-4' style={{borderTop: "1px solid #BFBFBF", paddingTop: "24px" }}>
              <Button className='mb-3' htmlType='submit' style={{background:"#720c20",color:"white",width:"90px",borderRadius:"2px",fontWeight:"500", height:"44px"}}>Add</Button>
            </div>
          </Form>
          </div>


        </Modal>

      </Form.Provider>

    </div>
  )
}

export default Coordinator